import { createFileRoute } from '@tanstack/react-router'
import PublishingSettings from '@/pages/settings/publishing'

export const Route = createFileRoute(
  '/(protected)/settings/publishing'
)({
  component: PublishingSettings,
})